import React from "react";

const SendIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0921 10.6428L22.0846 10.6396L2.06523 2.33612C1.89685 2.26565 1.71362 2.23801 1.53194 2.25567C1.35026 2.27334 1.17579 2.33577 1.02414 2.43737C0.863919 2.54236 0.732312 2.68553 0.64116 2.85401C0.550008 3.02248 0.502171 3.21098 0.501953 3.40253V8.713C0.502042 8.97487 0.593481 9.2285 0.760509 9.43018C0.927537 9.63186 1.15969 9.76896 1.41695 9.81784L12.3355 11.8367C12.3785 11.8449 12.4172 11.8677 12.445 11.9014C12.4729 11.935 12.4881 11.9773 12.4881 12.021C12.4881 12.0646 12.4729 12.1069 12.445 12.1406C12.4172 12.1742 12.3785 12.1971 12.3355 12.2052L1.41742 14.2241C1.16023 14.2728 0.928091 14.4098 0.760988 14.6113C0.593885 14.8128 0.502281 15.0662 0.501953 15.328V20.6394C0.501829 20.8223 0.547119 21.0024 0.63376 21.1635C0.720401 21.3246 0.845682 21.4616 0.99836 21.5624C1.18202 21.6844 1.39755 21.7496 1.61805 21.7499C1.77134 21.7497 1.92306 21.719 2.0643 21.6594L22.0832 13.4033L22.0921 13.3991C22.3616 13.2833 22.5912 13.091 22.7525 12.8461C22.9139 12.6011 22.9999 12.3143 22.9999 12.021C22.9999 11.7277 22.9139 11.4408 22.7525 11.1959C22.5912 10.9509 22.3616 10.7586 22.0921 10.6428Z"
        fill="#6A6C6D"
      />
    </svg>
  );
};

export default SendIcon;
